import React from "react";
import { DashboardData } from "../../types/dashboardData";
import { GraphicalDashboardCard } from "../../components/dashboard/GraphicalDashboardCard";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useCustomTranslation } from "../../provider/useCustomTranslation";

export function MembershipsCard(props: { data: DashboardData }) {
  const { data } = props;
  const { t } = useCustomTranslation();

  const options: ApexOptions = {
    series: data.members.membershipCountPerType.map(
      (membershipTypeCount) => membershipTypeCount.count
    ),
    labels: data.members.membershipCountPerType.map(
      (membershipTypeCount) => membershipTypeCount.membershipType.name
    ),
    colors: ["#4832BB", "#FD6A1C", "#70707050"],
  };

  return (
    <GraphicalDashboardCard
      gridProps={{ xs: 12, md: 6 }}
      title={t("pages.dashboard.membershipsByType")}
      resource={"membership-types"}
    >
      {data.members.membershipCountPerType.length > 0 ? (
        <Chart
          options={options}
          series={options.series}
          type="pie"
          width={500}
        />
      ) : (
        t("pages.dashboard.noData")
      )}
    </GraphicalDashboardCard>
  );
}
